import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const CrystalBallIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.75 6.75C13.75 8.66518 12.8137 10.3617 11.3738 11.4067C10.8091 11.8165 10.167 12.1261 9.47357 12.3094C9.0949 12.4095 8.70093 12.472 8.29589 12.4925C8.1979 12.4975 8.09923 12.5 8 12.5C7.60305 12.5 7.21549 12.4598 6.84117 12.3832C4.221 11.847 2.25 9.52868 2.25 6.75C2.25 3.57436 4.82436 1 8 1C11.1756 1 13.75 3.57436 13.75 6.75ZM9.00486 3.20097C9.02823 3.08412 9.13083 3 9.25 3C9.36917 3 9.47177 3.08412 9.49515 3.20097L9.96412 5.54584L11.8106 6.00746C11.9219 6.03529 12 6.13528 12 6.25C12 6.36472 11.9219 6.46471 11.8106 6.49254L9.96412 6.95416L9.49515 9.29903C9.47177 9.41588 9.36917 9.5 9.25 9.5C9.13083 9.5 9.02823 9.41588 9.00486 9.29903L8.53588 6.95416L6.68937 6.49254C6.57807 6.46471 6.5 6.36472 6.5 6.25C6.5 6.13528 6.57807 6.03529 6.68937 6.00746L8.53588 5.54584L9.00486 3.20097ZM6.01283 7.67094C6.04686 7.56886 6.14239 7.5 6.25 7.5C6.35761 7.5 6.45314 7.56886 6.48717 7.67094L6.69764 8.30236L7.32905 8.51282C7.43114 8.54684 7.5 8.64238 7.5 8.74998C7.5 8.85759 7.43115 8.95313 7.32906 8.98716L6.69764 9.19764L6.48717 9.82906C6.45314 9.93114 6.35761 10 6.25 10C6.14239 10 6.04686 9.93114 6.01283 9.82906L5.80236 9.19764L5.17094 8.98716C5.06885 8.95313 5 8.85759 5 8.74998C5 8.64238 5.06886 8.54684 5.17095 8.51282L5.80236 8.30236L6.01283 7.67094Z"
			></path>
			<path
				fill="currentColor"
				d="M4.16974 13.081L4.07054 13.4318C4.02632 13.5882 4.05875 13.7594 4.18304 13.8641C4.30395 13.9659 4.44715 14.0603 4.59281 14.1442C4.83616 14.2844 5.13806 14.4248 5.48243 14.5499C6.16967 14.7995 7.06078 15.0004 8.04098 15.0004C9.03899 15.0004 9.93675 14.7618 10.614 14.4995C11.0836 14.3176 11.4735 14.1139 11.7376 13.9479C11.9033 13.8437 11.9678 13.6421 11.9176 13.453L11.8224 13.095C11.7353 12.7672 11.3533 12.6193 11.0509 12.7728C10.1346 13.2379 9.09791 13.5 8.00003 13.5C6.89794 13.5 5.85753 13.2359 4.93867 12.7675C4.63942 12.6149 4.26113 12.7577 4.16974 13.081Z"
			></path>
		</svg>
	),
)
